var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import PersonalizeClient from "../../clients/AmazonPersonalizeClient";
import ProductClient from "../../clients/ProductClient";
import GoogleTagManagerUtil from "../../utils/google-tag-manager/GoogleTagManagerUtil";
import { ListNameEnum } from "../../@types/enums/ListNameEnum";
var personalizeClient = new PersonalizeClient();
var productClient = new ProductClient();
var useRecommendationsList = function (props) {
    var _a;
    var perPage = (_a = props === null || props === void 0 ? void 0 : props.perPage) !== null && _a !== void 0 ? _a : 10;
    var _b = useState(false), isLoading = _b[0], setLoading = _b[1];
    var _c = useState(), recommendationListCommand = _c[0], setRecommendationListCommand = _c[1];
    var _d = useState(), recommendedProductIds = _d[0], setRecommendedProductIds = _d[1];
    var _e = useState(null), paginatedData = _e[0], setPaginatedData = _e[1];
    var _f = useState(null), message = _f[0], setMessage = _f[1];
    var getRecommendedProductIds = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var itemList, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!recommendationListCommand) {
                        return [2];
                    }
                    setLoading(true);
                    setMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, personalizeClient.listRecommendations(recommendationListCommand)];
                case 2:
                    itemList = (_a.sent()).itemList;
                    setRecommendedProductIds(itemList.map(function (item) { return item.itemId; }));
                    return [3, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3, 5];
                case 4:
                    setLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [recommendationListCommand]);
    var getRecommendations = useCallback(function (page) {
        if (page === void 0) { page = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!recommendedProductIds) {
                            return [2];
                        }
                        setLoading(true);
                        setMessage(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, productClient.listProductsInStockByIds(recommendedProductIds, page, perPage)];
                    case 2:
                        response = _a.sent();
                        setPaginatedData(response);
                        return [3, 5];
                    case 3:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [3, 5];
                    case 4:
                        setLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    }, [recommendedProductIds, perPage]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = window === null || window === void 0 ? void 0 : window.onnit_context) === null || _a === void 0 ? void 0 : _a.personalize.enable)) {
            console.error("Personalize: Unable to get recommendations, `window.onnit_context.personalize.enable` is not true");
            return;
        }
        var userId = ((_b = window === null || window === void 0 ? void 0 : window.onnit_context) === null || _b === void 0 ? void 0 : _b.personalize.user_id) || ((_c = window === null || window === void 0 ? void 0 : window.onnit_context) === null || _c === void 0 ? void 0 : _c.personalize.session_id);
        if (!userId) {
            console.error("Personalize: Unable to get recommendations, `window.onnit_context.personalize.user_id` and `window.onnit_context.personalize.session_id` are unavailable.");
            return;
        }
        var userContext = {
            PAGE_TYPE: (props === null || props === void 0 ? void 0 : props.pageType) || "ACCOUNT_PAGE",
        };
        var country = (_d = window === null || window === void 0 ? void 0 : window.onnit_context) === null || _d === void 0 ? void 0 : _d.personalize.country;
        if (country) {
            userContext.COUNTRY = country;
        }
        var device = (_e = window === null || window === void 0 ? void 0 : window.onnit_context) === null || _e === void 0 ? void 0 : _e.personalize.device;
        if (device) {
            userContext.DEVICE = device;
        }
        setRecommendationListCommand({ userId: userId, userContext: userContext });
    }, []);
    useEffect(function () {
        if (!recommendationListCommand) {
            return;
        }
        getRecommendedProductIds().catch(console.log);
    }, [recommendationListCommand, getRecommendedProductIds]);
    useEffect(function () {
        if (!recommendedProductIds) {
            return;
        }
        getRecommendations().catch(console.log);
    }, [recommendedProductIds, getRecommendations]);
    useEffect(function () {
        var _a;
        if ((_a = paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.data) === null || _a === void 0 ? void 0 : _a.length) {
            GoogleTagManagerUtil.productImpression(paginatedData.data, ListNameEnum.RECOMMENDATIONS);
        }
    }, [paginatedData]);
    return {
        isLoading: isLoading,
        paginatedData: paginatedData,
        getRecommendations: getRecommendations,
        message: message,
    };
};
export default useRecommendationsList;
//# sourceMappingURL=useRecommendationsList.js.map